'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AblyRealtime = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ably = require('ably');

var _ably2 = _interopRequireDefault(_ably);

var _createSentryLogger = require('conversations-infrastructure/sentry/createSentryLogger');

var _AblyRealtimeWrapper = require('../api-wrappers/AblyRealtimeWrapper');

var _getLogLevel = require('../operators/getLogLevel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ablyLogger = (0, _createSentryLogger.createSentryLogger)({
  maxLines: 25,
  sentryDataKey: 'ablyLogs'
});

var AblyRealtime = exports.AblyRealtime = function AblyRealtime(clientOptions, lifecycleHooks) {
  var realtime = new _ably2.default.Realtime(_extends({}, clientOptions, {
    autoConnect: false,
    environment: 'hubspot',
    fallbackHosts: ['a-fallback-hubspot.ably.io', 'b-fallback-hubspot.ably.io'],
    log: {
      level: (0, _getLogLevel.getLogLevel)(),
      handler: function handler(line) {
        return ablyLogger.log(line);
      }
    }
  }));

  return new _AblyRealtimeWrapper.AblyRealtimeWrapper(realtime, lifecycleHooks);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/builders/AblyRealtime.js
// module id = 772
// module chunks = 2 3